import React from "react";
import { cn } from "@/lib/utils";
import { CdnIcon } from "@westayltd/icons/react";

export interface CounterProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  className?: string;
  disabled?: boolean;
}

export function Counter({
  value,
  onChange,
  min = 0,
  max = 999,
  className,
  disabled = false,
}: CounterProps) {
  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div
      className={cn(
        "flex items-center justify-between border border-background-200/70 rounded-xl px-3 py-2.5 bg-white",
        className
      )}
    >
      <button
        type="button"
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        className="w-8 h-8 flex items-center justify-center rounded-full border border-background-200/70 text-foreground-600 hover:border-foreground-300 hover:text-foreground-900 transition-colors disabled:opacity-40 disabled:cursor-not-allowed shrink-0"
      >
        <CdnIcon name="interface-remove-1--button-delete-buttons-subtract-horizontal-remove-line-add--Streamline-Core" size={14} />
      </button>

      <span className="text-base font-semibold text-foreground-950 w-10 text-center tabular-nums">
        {value}
      </span>

      <button
        type="button"
        onClick={handleIncrement}
        disabled={disabled || value >= max}
        className="w-8 h-8 flex items-center justify-center rounded-full border border-background-200/70 text-foreground-600 hover:border-foreground-300 hover:text-foreground-900 transition-colors shrink-0"
      >
        <CdnIcon name="interface-add-1--expand-cross-buttons-button-more-remove-plus-add--Streamline-Core" size={14} />
      </button>
    </div>
  );
}
